import { useState } from "react";
import { AdminModules } from "../features";
import {
  ConfirmationDeleteModal,
  useLanguageTranslator,
} from "../../../../components";
import { useApolloQuery } from "../../../../hooks";
import { gql, useMutation } from "@apollo/client";
import { useNotify } from "../../../../components/@common/NotificationsProvider";
import { useAuthSession } from "../../../../components/AuthSessionProvider";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const GET_COUNTRIES_WITH_PAGINATION = gql`
  query GetCountriesWithPagination($page: Int!) {
    countriesWithPagination(page: $page) {
      collection {
        id
        name
        createdAt
        updatedAt
      }
      metadata {
        currentPage
        limitValue
        totalCount
        totalPages
      }
    }
  }
`;

const DELETE_COUNTRY = gql`
  mutation DeleteCountry($id: ID!) {
    countryDelete(input: { id: $id }) {
      clientMutationId
      country {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
`;

function Country() {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isOpenDelete, setIsOpenDelete] = useState({ status: false, data: {} });

  const { translator } = useLanguageTranslator();
  const notify = useNotify();
  const navigate = useNavigate();
  const { user } = useAuthSession() as any;

  const { data, loading, refetch } = useApolloQuery({
    queryDocument: GET_COUNTRIES_WITH_PAGINATION,
    isPrivateCall: true,
    variables: {
      page: page,
    },
  });

  const [deleteCountry, { loading: deleteLoading, error }] = useMutation(
    DELETE_COUNTRY,
    {
      refetchQueries: ["GetCountries"],
      context: {
        headers: {
          "access-token": user?.accessToken,
          client: user?.client,
          uid: user?.email,
        },
      },
    }
  );

  const modifiedGetCountries = data?.countriesWithPagination?.collection?.map(
    (item: any) => {
      return {
        sr: item?.id,
        id: item?.id,
        name: item?.name,
        createdAt: dayjs(item?.createdAt?.split("T")?.[0] || "").format(
          "DD.MM.YYYY"
        ),
        updatedAt: dayjs(item?.updatedAt?.split("T")?.[0] || "").format(
          "DD.MM.YYYY"
        ),
      };
    }
  );

  async function onClickHandler(type: string, clickedId: any) {
    if (type === "edit") {
      navigate(`/admin/country/update?id=${clickedId}`);
      return;
    }

    if (type === "delete") {
      setIsOpenDelete({ status: true, data: { id: clickedId } });
    }
  }

  async function onClickDeleteHandler(item: any) {
    const response = await deleteCountry({
      variables: { id: Number(item?.id) },
    });
    if (response?.data) {
      notify.success(`${translator("Country")} Delete successfuly!`);
      setIsOpenDelete({ status: false, data: {} });
      setTimeout(async () => {
        await refetch();
      }, 1000);
    }
  }

  function handleDeleteClose() {
    setIsOpenDelete({ status: false, data: {} });
  }

  return (
    <>
      <ConfirmationDeleteModal
        isOpen={isOpenDelete?.status}
        item={isOpenDelete?.data}
        onClickHandler={onClickDeleteHandler}
        handleClose={handleDeleteClose}
      />
      <AdminModules
        title={translator("Country")}
        path="/admin/country/add-new"
        data={modifiedGetCountries}
        moduleKey="country-module"
        page={page}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        setPage={setPage}
        onClickHandler={onClickHandler}
        metadata={data?.countriesWithPagination?.metadata}
      />
    </>
  );
}

export { Country };
